import _ from 'lodash';
import { useRooms } from '../hooks/useRooms';
import { getInspirationsPageListApi, getRoomsPageListApi } from '../api/myprojects';
import GridSectionNew from './GridSectionNew';
import { Recent_First_Value } from '../constants/filters';
import { EditRoomPopup } from './EditRoomPopup/EditRoomPopup';
import { paginatedRoomsActions } from '../redux/slicers/admin/paginatedRooms';
import { useDispatch } from 'react-redux';
import { MxEvent } from './Mixpanel';

export default function GridRoomsSection({ title, seeAllLink, modelType, emptyDisplay }) {
  const dispatch = useDispatch();
  const { list, loading, total } = useRooms({ 
    defaultSort: '-inspiration',
    api: getRoomsPageListApi
  });

  const handleRoomUpdate = (newData) => {
    dispatch(paginatedRoomsActions.update(newData));
  };

  return (
    <>
      <GridSectionNew
        title={title}
        itemsTotal={total}
        seeAllLink={seeAllLink}
        carouselData={list}
        modelType={modelType}
        loading={loading}
        emptyDisplay={emptyDisplay}
        mx_event={MxEvent.VISITED_INSPIRATIONS}
      />
      <EditRoomPopup onUpdateSuccess={handleRoomUpdate} />
    </>
  );
}
